import Component from '@bythepixel/component-loader';
import Splide from '@splidejs/splide';
import windowMatchMedia from '@Front/constants/windowMatchMedia';
import { selectors, splideOptions } from './config';

export default class SectionCardSlider extends Component {
  static selector = '[data-comp-card-slider]';

  slider;

  constructor(containerEl) {
    super(containerEl);
    this.text = containerEl.querySelector(selectors.text);
    this.wrapper = containerEl.querySelector(selectors.wrapper);
    this.track = containerEl.querySelector(selectors.track);

    this.#buildSlider();
    this.mount();
  }

  currentSlide() {
    return this.slider.index;
  }

  #forceNoTextTransition() {
    this.text.classList.add('no-transition');

    // without the timeout, the transition still occurs
    setTimeout(() => this.text.classList.remove('no-transition'));
  }

  #buildSlider() {
    this.slider = new Splide('.splide', splideOptions);
    this.slider.mount();
  }

  #attachListeners() {
    this.slider.on('move', (newIndex) => {
      const isLastSlide = newIndex === this.slider.length - 1;
      this.$container.dataset.currentSlide = newIndex;
      this.track.dataset.onLastSlide = isLastSlide;
    });

    windowMatchMedia['break-2'].addListener((e) => {
      const screenIsTablet = !e.matches;

      if (screenIsTablet) return;

      // prevents the text from fading up behind the cards if a user
      // widens their viewport while they're not on the first slide
      if (this.currentSlide() > 0) {
        this.#forceNoTextTransition();
      }
    });
  }

  mount() {
    this.#attachListeners();
  }
}
